var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04877 17.4371C2.18825 17.4597 2.32941 17.4702 2.47065 17.4683L26.5198 17.4683L25.9954 17.7122C25.4828 17.9548 25.0165 18.285 24.6173 18.6879L17.8733 25.4318C16.9851 26.2797 16.8359 27.6437 17.5197 28.6636C18.3155 29.7504 19.8417 29.9864 20.9286 29.1906C21.0164 29.1262 21.0998 29.0561 21.1783 28.9807L33.3735 16.7854C34.3266 15.8334 34.3274 14.2891 33.3754 13.336C33.3748 13.3354 33.3741 13.3347 33.3735 13.3341L21.1783 1.13887C20.2244 0.187716 18.6801 0.189848 17.7289 1.14367C17.6541 1.21875 17.5842 1.29863 17.5197 1.38277C16.8359 2.40268 16.9851 3.76664 17.8733 4.61452L24.6051 11.3707C24.963 11.7289 25.3744 12.0293 25.8247 12.2609L26.5564 12.5902L2.60487 12.5902C1.35889 12.544 0.265739 13.4143 0.0316658 14.639C-0.18396 15.9687 0.719101 17.2214 2.04877 17.4371Z",
    fill: "#0FAA8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.bdc23ba180d29cb8ea519ec9327059b3.svg";
export { ForwardRef as ReactComponent };